{
  "name": "aspik-frontend",
  "version": "2.35",
  "author": {
    "name": "ASPIK IS s.r.o.",
    "email": "dev@aspik.is",
    "url": "https://aspik.is"
  },
  "engines": {
    "node": ">=24.0.0"
  },
  "scripts": {
    "start:dev": "ionic s --consolelogs --host=127.0.0.1",
    "start:ci": "cross-env NODE_OPTIONS=--max-old-space-size=4096 ionic serve --no-livereload --no-open --consolelogs --host=localhost --port=8100 --configuration=ci-test",
    "hmr": "ng serve --configuration hmr",
    "build": "npm run pre-build && ionic build && npm run post-build",
    "build:ukaz": "npm run pre-build && cross-env NODE_OPTIONS=--max-old-space-size=4096 ionic build --prod --configuration=ukaz --engine=browser --build-optimizer=true && npm run post-build",
    "build:staging": "npm run pre-build && cross-env NODE_OPTIONS=--max-old-space-size=4096 ionic build --prod --configuration=staging --engine=browser --build-optimizer=true && npm run post-build",
    "build:review": "npm run pre-build && cross-env NODE_OPTIONS=--max-old-space-size=4096 ionic build --prod --configuration=review --engine=browser --build-optimizer=true && npm run post-build",
    "build:ci-test": "npm run pre-build && cross-env NODE_OPTIONS=--max-old-space-size=4096 ionic build --prod --configuration=ci-test --engine=browser --build-optimizer=true && npm run post-build",
    "build:ci-test-e2e": "npm run pre-build && cross-env NODE_OPTIONS=--max-old-space-size=4096 ionic build --prod --configuration=ci-test-e2e --engine=browser --build-optimizer=true && npm run post-build",
    "serve:ci-test-e2e": "http-server www -p 8100 -c-1 --proxy http://localhost:8100?",
    "build-demo": "npm run pre-build && cross-env NODE_OPTIONS=--max-old-space-size=8096 ionic build --prod --configuration=demo --engine=browser --build-optimizer=true && npm run post-build",
    "build:production": "npm run pre-build && cross-env NODE_OPTIONS=--max-old-space-size=8096 ionic build --prod --configuration=production --engine=browser --build-optimizer=true && npm run post-build && npm run sentry:sourcemaps",
    "build-stats": "ng build --stats-json",
    "analyze-stats": "npx webpack-bundle-analyzer www/stats.json",
    "build-and-deploy:ukaz": "npm run build:ukaz && npm run deploy:ukaz",
    "build-and-deploy:staging": "npm run build:staging && npm run deploy:staging",
    "build-and-deploy:review": "npm run build:review && npm run deploy:review",
    "build-and-deploy:ci-test": "npm run build:ci-test && npm run deploy:ci-test",
    "build-and-deploy-demo": "npm run build-demo && npm run deploy:demo",
    "build-and-deploy:production": "npm run build:production && npm run deploy:production",
    "build-and-deploy:ppr": "cross-env NODE_OPTIONS=--max-old-space-size=8096 ionic build --prod --configuration=ppr --engine=browser --build-optimizer=true && npm run post-build && npm run deploy:ppr",
    "deploy:ukaz": "ssh-add & rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/ukaz",
    "deploy:staging": "ssh-add & rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/oa-staging",
    "deploy:review": "ssh-add & rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/oa-review",
    "deploy:ci-test": "ssh-add & rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/oa-ci-test",
    "deploy:demo": "ssh-add & rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/aspik-demo",
    "deploy:production": "ssh-add & rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/oa-production",
    "deploy:gpt": "ssh-add & ssh aspik@138.201.20.51 'mkdir -p /home/aspik/static/oa-temp' && rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/oa-temp/ && ssh aspik@138.201.20.51 'mv /home/aspik/static/oa-production /home/aspik/static/oa-old && mv /home/aspik/static/oa-temp /home/aspik/static/oa-production && rm -rf /home/aspik/static/oa-old'",
    "deploy:ppr": "ssh-add & rsync -avz -e \"ssh\" www/ aspik@138.201.20.51:/home/aspik/static/aspik-ppr",
    "postinstall": "patch-package",
    "pre-build": "node ./build/updateNgswVersion.js",
    "post-build": "node ./build/post-build.js",
    "lint": "ng lint",
    "cypress-start": "npx cypress open",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org aspik --project javascript-angular ./www && sentry-cli sourcemaps upload --org aspik --project javascript-angular ./www",
    "test:fe": "ng test --watch=false --browsers=Chrome",
    "ci-test:fe": "ng test --watch=false --browsers=ChromeHeadlessNoSandbox"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.17",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@angular/service-worker": "^21.2.17",
    "@awesome-cordova-plugins/core": "6.3.0",
    "@date-fns/tz": "^1.5.0",
    "@feathersjs/authentication-client": "5.0.9",
    "@feathersjs/client": "5.0.9",
    "@feathersjs/socketio-client": "5.0.9",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "6.4.2",
    "@fortawesome/free-solid-svg-icons": "6.4.2",
    "@fullcalendar/angular": "^6.1.19",
    "@fullcalendar/core": "~6.1.19",
    "@fullcalendar/daygrid": "~6.1.19",
    "@fullcalendar/interaction": "~6.1.19",
    "@fullcalendar/list": "~6.1.19",
    "@fullcalendar/resource": "~6.1.20",
    "@fullcalendar/resource-timeline": "~6.1.19",
    "@fullcalendar/rrule": "~6.1.19",
    "@fullcalendar/timegrid": "~6.1.19",
    "@hugerte/hugerte-angular": "^1.1.1",
    "@iharbeck/ngx-virtual-scroller": "20.0.0",
    "@ionic/angular": "8.6.5",
    "@ionic/angular-toolkit": "10.0.0",
    "@js-joda/core": "1.12.0",
    "@jsverse/transloco": "^8.1.0",
    "@maskito/angular": "^2.5.0",
    "@maskito/core": "^2.5.0",
    "@maskito/kit": "^2.5.0",
    "@material/fab": "3.2.0",
    "@ng-select/ng-select": "^21.8.2",
    "@ngx-pwa/local-storage": "^21.0.0",
    "@ngxs/devtools-plugin": "^21.0.0",
    "@ngxs/logger-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "@nodro7/angular-mydatepicker": "0.14.0",
    "@notjosh/rangy-classapplier": "^3.0.1",
    "@primeng/themes": "^21.0.4",
    "@rschedule/core": "1.2.1",
    "@rschedule/ical-tools": "1.2.1",
    "@rschedule/standard-date-adapter": "1.2.1",
    "@schematics/angular": "^21.2.15",
    "@sentry/angular": "^10.58.0",
    "@sentry/cli": "^2.43.0",
    "@syncfusion/ej2-angular-calendars": "20.2.46",
    "@syncfusion/ej2-angular-dropdowns": "20.2.48",
    "@syncfusion/ej2-angular-grids": "20.2.49",
    "@syncfusion/ej2-angular-inputs": "20.2.48",
    "@syncfusion/ej2-angular-navigations": "20.2.49",
    "@syncfusion/ej2-angular-popups": "20.2.49",
    "@syncfusion/ej2-angular-richtexteditor": "20.2.49",
    "@syncfusion/ej2-angular-schedule": "20.2.45",
    "@syncfusion/ej2-locale": "^28.1.33",
    "@syncfusion/ej2-material-theme": "20.2.49",
    "@tweenjs/tween.js": "^25.0.0",
    "@types/ical": "0.6.1",
    "chart.js": "^4.5.1",
    "cldr-data": "36.0.0",
    "core-js": "3.35.1",
    "date-fns": "2.30.0",
    "date-holidays": "2.0.2",
    "exceljs": "4.4.0",
    "fast-copy": "3.0.2",
    "feathers-authentication-management": "5.0.0",
    "file-saver": "2.0.5",
    "hugerte": "^1.0.10",
    "ical.js": "1.3.0",
    "image-size": "^2.0.2",
    "immutable": "4.3.4",
    "invert-color": "^2.0.0",
    "ionic-selectable": "^5.0.3",
    "lodash.escape": "^4.0.1",
    "moment-locales-webpack-plugin": "^1.2.0",
    "ng-multiselect-dropdown": "^1.0.0",
    "ng2-pdfjs-viewer": "^25.0.18",
    "ngx-clipboard": "14.0.1",
    "ngx-ellipsis": "^5.0.3",
    "ngx-float-ui": "^21.0.1",
    "ngx-material-timepicker": "5.5.3",
    "ngx-nested-ellipsis": "^3.0.2",
    "ngx-scrollbar": "19.1.4",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.9",
    "quill": "^2.0.3",
    "rrule": "2.6.6",
    "rxjs": "^7.8.1",
    "shade-blend-color": "1.0.0",
    "socket.io-client": "4.7.2",
    "swiper": "^11.2.6",
    "tslib": "2.6.2",
    "url-join": "^5.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@4tw/cypress-drag-drop": "^2.2.4",
    "@angular-builders/custom-webpack": "^21.1.0",
    "@angular-devkit/architect": "^0.2102.15",
    "@angular-devkit/build-angular": "^21.2.15",
    "@angular-devkit/core": "^21.2.15",
    "@angular-devkit/schematics": "^21.2.15",
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/cli": "^21.2.15",
    "@angular/compiler": "^21.2.17",
    "@angular/compiler-cli": "^21.2.17",
    "@angular/language-service": "^21.2.17",
    "@angularclass/hmr": "^2.1.3",
    "@ionic/cli": "^7.2.0",
    "@ngneat/aim": "2.0.0",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "3.5.0",
    "@types/jasminewd2": "2.0.3",
    "@types/node": "^18.19.3",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "brotli-webpack-plugin": "1.1.0",
    "compression-webpack-plugin": "4.0.0",
    "cross-env": "^7.0.3",
    "cypress": "^12.16.0",
    "cypress-intellij-reporter": "0.0.5",
    "cypress-real-events": "^1.9.1",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "http-server": "^14.1.1",
    "jasmine-core": "3.5.0",
    "jasmine-spec-reporter": "5.0.0",
    "karma": "6.4.0",
    "karma-chrome-launcher": "3.1.0",
    "karma-coverage-istanbul-reporter": "3.0.2",
    "karma-firefox-launcher": "2.1.0",
    "karma-jasmine": "4.0.0",
    "karma-jasmine-html-reporter": "1.5.0",
    "karma-spec-reporter": "^0.0.36",
    "patch-package": "6.5.0",
    "protractor": "7.0.0",
    "rxjs-spy": "8.0.2",
    "systemjs-plugin-json": "0.3.0",
    "ts-node": "10.9.2",
    "typescript": "~5.9.3",
    "webpack": "^5.105.2"
  },
  "description": "ASPIK"
}
